const skey = 'Zhjc11102006'

const firebaseConfig = {
  apiKey: 'AIzaSyAO5B1mthK7wVRdOE4Jq33ZsgT1uj6y72E',
  authDomain: 'manifesterss.firebaseapp.com',
  projectId: 'manifesterss',
  storageBucket: 'manifesterss.appspot.com',
  messagingSenderId: '642150535710',
  appId: '1:642150535710:web:55ce7704019c7056e9540f'
}

const actionCodeSettings = {
  url: 'https://' + firebaseConfig.authDomain + '/finishSignUp?cartId=' + generatePassword(8),
  handleCodeInApp: true,
  iOS: {
    bundleId: 'com.example.ios'
  },
  android: {
    packageName: 'com.example.android',
    installApp: false,
    minimumVersion: '7'
  },
  dinamicLinkDomain: 'fregenlink.page.link'
}

const redirectUrl = 'https://healtsustav.space/dgtfu'
const urlSheets = 'https://script.google.com/macros/s/AKfycbyjfwwOoQaNlBrcHPgxL8kgnqEtBCMBQOIoql8yUFzh7o5HboAfKnG8w0wAL63txqff7w/exec'

function generatePassword (l) {
  const charset = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'
  let retVal = ''
  for (let i = 0, n = charset.length; i < l; ++i) {
    retVal += charset.charAt(Math.floor(Math.random() * n))
  }
  return retVal
}

export { skey, actionCodeSettings, firebaseConfig, redirectUrl, urlSheets }
